import React, { createContext, useReducer, useEffect } from 'react';

export const AuthContenxt = createContext();

const getStoredUser = () => {
    try {
        const storedUser = localStorage.getItem("user");
        return storedUser ? JSON.parse(storedUser) : null;
    } catch (error) {
        console.error('Error parsing stored user:', error);
        localStorage.removeItem("user");
        return null;
    }
}

export const authReducer = (state, action) => {
    switch (action.type) {
        case 'LOGIN':
            return { user: action.payload };
        case 'LOGOUT':
            return { user: null };
        default:
            return state;
    }
}

export const AuthContenxtProvider = ({ children }) => {
    const [state, dispatch] = useReducer(authReducer, {
        user: getStoredUser()
    })
    useEffect(() => {
        const user = getStoredUser();
        if (user) dispatch({ type: 'LOGIN', payload: user })
    }, [])


    return (
        <AuthContenxt.Provider value={{ ...state, dispatch }}>
            {children}
        </AuthContenxt.Provider>
    )
}
